import React from 'react';

import PrivacyPolicy from './PrivacyPolicy';
import AuthContainer from 'src/components/AuthContainer';
import ForgotPw from './Password/ForgotPw';
import ResetPw from './Password/ResetPw';
import SignInCode from './SignInCode';
import Profile from './Profile';
import Subscription from './Subscription';
import InviteSignup from './InviteSignup';

import OAuth from './OAuth';
import TestGuide from './TestGuide';

const publicRouters = {
  PRIVACY_POLICY_PAGE: {
    name: 'privacypolicy',
    path: '/privacypolicy',
    element: (
      <AuthContainer enableFooter={false} enableWrap={false}>
        <PrivacyPolicy />
      </AuthContainer>
    )
  },
  INVITE_SIGNUP_PAGE: {
    name: 'invite_signup',
    path: '/invite_signup',
    element: <InviteSignup />
  },
  OAUTH_PAGE: {
    name: 'oauth',
    path: '/oauth',
    element: <OAuth />
  },
  PROFILE_PAGE: {
    name: 'profile_page',
    path: '/:username/:tab?',
    match: (u, tab) => `/${u}${tab ? '/' + tab : ''}`,
    // checkActive: ({ pages }) => !window.location.href.includes('/admin'),
    element: <Profile />
  },
  FORGOT_PASSWORD_PAGE: {
    path: '/forgot_pw',
    element: (
      <AuthContainer>
        <ForgotPw />
      </AuthContainer>
    )
  },
  RESET_PASSWORD_PAGE: {
    path: '/reset_pw',
    element: (
      <AuthContainer>
        <ResetPw />
      </AuthContainer>
    )
  },
  SIGNIN_CODE: {
    path: '/signin_code',
    element: <SignInCode />
  },
  SUBSCRIPTION_PAGE: {
    path: '/subscription',
    element: <Subscription />
  },
  TEST_GUIDE_PAGE: {
    name: 'test_guide',
    path: '/test_guide',
    element: <TestGuide />
  }
};

export default publicRouters;
